import { Component, OnInit } from '@angular/core';
import { BasePageComponent } from 'src/app/shared/components/base/base-page.component';
import { Router } from '@angular/router';
import { ReconciliationModel } from 'src/app/shared/models/domain/reconciliation.model';
import { NotificationService } from 'src/app/core/services/app/notification.service';

@Component({
  selector: 'app-reconciliations',
  templateUrl: './reconciliations-page.component.html',
  styleUrls: ['./reconciliations-page.component.scss']
})
export class ReconciliationsPageComponent extends BasePageComponent implements OnInit {
  hasDraft = null;

  constructor(
    private router: Router,
    private notificationService: NotificationService) {
    super();
  }

  ngOnInit(): void {
  }

  onRowClicked(event: { data: ReconciliationModel }): void {
    this.router.navigateByUrl(this.routeUtilities.routes.application.reconciliationEdit.getNavigateUrl(event.data.reconciliationKey));
  }

  onDataLoaded(data: any): void {
    this.hasDraft = !!data.find(t => t.isDraft);
  }

  onAddButtonClicked(): void {
    if (this.hasDraft === false) {
      this.router.navigateByUrl(this.routeUtilities.routes.application.reconciliationAdd.getNavigateUrl());
    } else if (this.hasDraft) {
      this.notificationService.showErrorNotification('You cannot create another reconciliation when you already have a draft in progress.');
    }
  }
}
